import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

function RouteWithLayout(props) {
	const { component: Component, ...rest } = props;

	return <Route {...rest} component={Component} />;
}

RouteWithLayout.propTypes = {
	component: PropTypes.any.isRequired,
	//helmet: PropTypes.any.isRequired,
	//layout: PropTypes.any.isRequired,
	path: PropTypes.string
};

export default RouteWithLayout;
